import axios from "axios";

interface ISignInData {
  email: "string";
  password: "string";
}

export const signIn = async (data: ISignInData) => (await axios.post("/api/Auth/SignIn", data)).data;
